import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FileValueAccessor } from './file-value-accessor';
import { MatFormField } from '@angular/material/form-field';
import { FormlyMaterialModule } from '@ngx-formly/material';

@Component({
  selector: 'formly-field-file',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
      FormlyModule,
      ReactiveFormsModule,
      FileValueAccessor,
      FormlyMaterialModule,
  ],
  template: `<div class="mb-10"> <input #testUpload type="file" [formControl]="formControl" [formlyAttributes]="field" multiple/> </div>
`,
})
export class UploadControlComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {


    @ViewChild('testUpload') elementRef: ElementRef<any>;


    ngAfterViewInit(): void {


    }







}
